import { Reveal } from "../components/Reveal";
import { CONTACT } from "../data/site";

const Terms = () => (
  <section className="pt-32 sm:pt-40 pb-24" data-testid="terms-page">
    <div className="mx-auto max-w-3xl px-4 sm:px-8">
      <Reveal y={16}>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber">Legal</p>
        <h1 className="mt-4 font-display font-black uppercase tracking-tight text-5xl sm:text-7xl leading-[0.9]">
          Terms of Use
        </h1>
        <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
          {CONTACT.company}
        </p>
      </Reveal>

      <Reveal delay={0.1} className="mt-12 space-y-8 text-sm sm:text-base text-slate-400 leading-relaxed">
        <p>
          These terms govern your use of this website operated by {CONTACT.company} ("MAXIMUS TREADS"). By
          using the site you agree to them.
        </p>
        <div>
          <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white">1. Enquiries, not orders</h2>
          <p className="mt-3">
            This website is an information and enquiry platform. Submitting a quote request creates no contract
            and involves no online payment. All orders are concluded directly with our team by phone or email.
          </p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white">2. Product information</h2>
          <p className="mt-3">
            Product names, sizes and specifications shown are reproduced from our current catalogue and are
            subject to change and confirmation at the time of quotation. Images are illustrative.
          </p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white">3. Quotations</h2>
          <p className="mt-3">
            Quotations are prepared individually based on your stated requirements — product, sizes, volumes
            and delivery location — and are valid for the period stated on the quotation.
          </p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white">4. Intellectual property</h2>
          <p className="mt-3">
            The MAXIMUS TREADS name, product names and website content remain the property of {CONTACT.company}
            and may not be reproduced without permission.
          </p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white">5. Liability</h2>
          <p className="mt-3">
            Website content is provided in good faith. Product performance depends on application and retreading
            practice; nothing on this site constitutes a technical warranty, which is provided only in writing
            with a confirmed order.
          </p>
        </div>
        <div>
          <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-white">6. Contact</h2>
          <p className="mt-3">
            {CONTACT.company}, {CONTACT.addressLines[0]}, {CONTACT.addressLines[1]} — phone{" "}
            {CONTACT.phones.map((p) => `+91 ${p}`).join(" / ")} or email{" "}
            <a href={`mailto:${CONTACT.email}`} className="text-amber hover:underline" data-testid="terms-email-link">{CONTACT.email}</a>.
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);

export default Terms;
